import api from './api';

export const getSummerSportsRegistrations = async () => {
    return api.get('/api/summer-sports/registrations');
};
